/** Security 专题文章（飞书 PRD 三篇 Post） */

const securityArticles = [
  {
    slug: 'is-gb-whatsapp-safe-to-use',
    path: '/is-gb-whatsapp-safe-to-use/',
    title: 'Is GB WhatsApp Safe? 7 Checks Before Installing an APK',
    description:
      'Thinking about installing GB WhatsApp? Learn how to check an APK source, review Android permissions, spot suspicious installers and respond to security warnings.',
    keywords: 'is gb whatsapp safe, gb whatsapp apk security, gb whatsapp permissions',
    h1: 'Is GB WhatsApp Safe? 7 Checks Before Installing an APK',
    cardSummary:
      'Learn about potential privacy and security risks associated with GB WhatsApp and what to consider before installing an APK.',
    blocks: [
      {
        type: 'p',
        html: 'You cannot judge whether a GB WhatsApp APK is safe from version numbers, download counts or a “virus-free” badge alone. Check the file source, installation flow, permissions and any security warnings on your device before you install.',
      },
      { type: 'h2', text: 'How Can You Check Whether a GB WhatsApp APK Is Safe?' },
      { type: 'h3', text: 'Check Where the APK Comes From' },
      {
        type: 'ul',
        items: [
          'See whether the site clearly states the file source, version number and release date.',
          'Watch for multiple redirect pages, fake download buttons or pages that push unrelated apps.',
          'Remember that HTTPS only encrypts the connection—it does not prove the APK itself is safe.',
        ],
      },
      { type: 'h3', text: 'Scan the File Before Opening It' },
      {
        type: 'ul',
        items: [
          'Use Android security features such as Google Play Protect before opening the file.',
          'If you use a multi-engine scanner, treat results as guidance only—not proof of safety.',
          'A clean scan does not guarantee the app has no malicious code or unwanted behavior.',
        ],
      },
      { type: 'h3', text: 'Review the App Permissions' },
      {
        type: 'p',
        html: 'After installation, open <strong>Settings → Apps → GB WhatsApp → Permissions</strong> (wording varies by device). Check whether each permission matches how you expect to use the app. Sensitive permissions are not always malicious, but unexpected access is a reason to pause.',
      },
      { type: 'h3', text: 'Watch for Unexpected Installation Requests' },
      {
        type: 'p',
        html: 'Be cautious if the installer asks for a second APK, unrelated configuration files, your account password or verification codes, or high-risk permissions that are not needed for normal messaging.',
      },
      { type: 'h3', text: "Check the App's Identity and Version" },
      {
        type: 'p',
        html: 'Version labels can be forged. Without a trusted signature or file hash to compare against, version text on a download page does not confirm authenticity.',
      },
      { type: 'h3', text: 'Pay Attention to Android Security Warnings' },
      {
        type: 'p',
        html: 'If Google Play Protect or Android shows a security warning, investigate before proceeding. Do not disable protection just to install an unknown file.',
      },
      { type: 'h3', text: 'Decide Whether the Risk Is Acceptable' },
      {
        type: 'p',
        html: 'Weigh source quality, permissions, scan results and system warnings together. These checks reduce guesswork but cannot guarantee safety for an unofficial APK.',
      },
      { type: 'h2', text: 'What Should You Do If You Already Installed a Suspicious APK?' },
      {
        type: 'ol',
        items: [
          'Stop using the suspicious app and avoid entering sensitive information.',
          'Run your device security tools and remove apps confirmed as risky.',
          'If you entered passwords or other sensitive data, change those credentials and monitor the accounts.',
          'If your WhatsApp account behaves oddly, check status through official WhatsApp channels.',
          'Do not install another unknown APK just to recover data.',
        ],
      },
      { type: 'h2', text: 'Is a GB WhatsApp APK Safe If It Passes a Virus Scan?' },
      {
        type: 'p',
        html: 'Not necessarily. Static scans miss some behaviors, and they do not prove how the app handles privacy, background activity or platform rules.',
      },
      { type: 'h2', text: 'Frequently Asked Questions' },
      { type: 'h3', text: 'Can a GB WhatsApp APK Contain Malware?' },
      {
        type: 'p',
        html: 'Unverified APKs can contain harmful code, but you should not assume every file is malicious without evidence.',
      },
      { type: 'h3', text: 'Does Google Play Protect Guarantee That an APK Is Safe?' },
      {
        type: 'p',
        html: 'No. It can flag some risks but does not guarantee a file is completely safe.',
      },
      { type: 'h3', text: 'Is GB WhatsApp Safe for Private Chats?' },
      {
        type: 'p',
        html: 'Consider what sensitive information you share, that privacy practices cannot be fully verified, and that the official WhatsApp app is the supported option for protected messaging.',
      },
      {
        type: 'p',
        html: 'If checks raise doubts, delay installation until you can verify the file—or use the official app. See the <a href="/security-guide/">Security Guide</a> and <a href="/old-versions/">Old Versions</a> pages for related context.',
      },
    ],
  },
  {
    slug: 'why-is-gb-whatsapp-account-banned',
    path: '/why-is-gb-whatsapp-account-banned/',
    title: 'GB WhatsApp Account Banned? Reasons and What to Do',
    description:
      'Is your GB WhatsApp account banned or temporarily restricted? Learn how to identify the warning, request a review and protect your chat history.',
    keywords: 'gb whatsapp banned, gb whatsapp account restricted, whatsapp unofficial client ban',
    h1: 'GB WhatsApp Account Banned? Reasons and What to Do',
    cardSummary:
      'Understand why using an unofficial WhatsApp client may lead to account restrictions and what options users can consider.',
    blocks: [
      {
        type: 'p',
        html: 'Two situations are often confused: a prompt to use the official app, and a message that your phone number cannot use WhatsApp. They are related but not identical—read the exact text on your screen before you act.',
      },
      { type: 'h2', text: 'Why Was Your GB WhatsApp Account Restricted?' },
      { type: 'h3', text: 'Using an Unofficial WhatsApp Client' },
      {
        type: 'p',
        html: 'WhatsApp states that unofficial clients can lead to temporary or permanent restrictions. No specific GB WhatsApp version is guaranteed to avoid enforcement.',
      },
      { type: 'h3', text: 'Unwanted or Automated Messaging' },
      {
        type: 'p',
        html: 'Spam, scams and unauthorized automation can violate platform rules. Normal chatting or installing an older APK is not, by itself, a confirmed ban trigger.',
      },
      { type: 'h3', text: 'A Login Error Is Not Always an Account Ban' },
      {
        type: 'p',
        html: 'Verification failures, network issues and app incompatibility can look like a “ban.” Read the full error message instead of guessing from a failed login alone.',
      },
      { type: 'h2', text: 'How to Tell What Happened to Your Account' },
      {
        type: 'table',
        headers: ['What You See', 'What It May Mean', 'What to Do'],
        rows: [
          [
            'A message asking you to use official WhatsApp',
            'The unofficial client is not accepted',
            'Follow the official app switching instructions',
          ],
          [
            'A temporary ban message or countdown',
            'A temporary restriction may be active',
            'Follow the displayed instructions and stop using the unofficial client',
          ],
          [
            '“This phone number can’t use WhatsApp”',
            'The account has been banned',
            'Check whether Request review is available',
          ],
          [
            'SMS or registration code problems',
            'Registration may be failing for another reason',
            'Check the number, network and official registration guidance',
          ],
        ],
      },
      { type: 'h2', text: 'What to Do If Your Account Is Banned' },
      { type: 'h3', text: 'Step 1: Check the Exact Ban Message' },
      {
        type: 'p',
        html: 'Note whether the screen shows a temporary timer, a permanent ban or only an unofficial-client warning. Do not rely on guesswork from error codes alone.',
      },
      { type: 'h3', text: 'Step 2: Use Request Review If It Is Available' },
      {
        type: 'p',
        html: 'For a clear ban screen, use in-app <strong>Request review</strong> when shown. Provide accurate details only—review does not guarantee reinstatement.',
      },
      { type: 'h3', text: 'Step 3: Stop Repeatedly Switching Modified Versions' },
      {
        type: 'p',
        html: 'Changing APK builds does not remove account-level restrictions and can make backups harder to manage.',
      },
      { type: 'h3', text: 'Step 4: Protect Your Chat History' },
      {
        type: 'p',
        html: 'Confirm existing backups and restore options before uninstalling. Third-party mod backups may not migrate cleanly.',
      },
      { type: 'h2', text: 'Can an Older GB WhatsApp Version Prevent a Ban?' },
      {
        type: 'p',
        html: 'No guarantee. Account limits are separate from app version numbers; downgrading does not ensure access returns.',
      },
      { type: 'h2', text: 'How Long Does a WhatsApp Ban Review Take?' },
      {
        type: 'p',
        html: 'WhatsApp help materials often cite about 24 hours for review, but timing can vary. Treat any estimate as guidance, not a promise.',
      },
      { type: 'h2', text: 'Frequently Asked Questions' },
      { type: 'h3', text: 'Can I Get My GB WhatsApp Account Back?' },
      {
        type: 'p',
        html: 'It depends on the restriction type and the outcome of any official review.',
      },
      { type: 'h3', text: 'Will Changing My APK Version Remove the Ban?' },
      { type: 'p', html: 'There is no guarantee that switching versions will lift a ban.' },
      { type: 'h3', text: 'Should I Contact Third-Party Websites to Unban My Account?' },
      {
        type: 'p',
        html: 'Third-party sites cannot remove WhatsApp enforcement. Be wary of paid “unban” services.',
      },
      {
        type: 'p',
        html: 'Quick check: read the exact message → protect backups → use official review if offered → avoid random APK swaps. More help: <a href="/security-guide/">Security Guide</a>, <a href="/old-versions/">Old Versions</a>, and <a href="/gb-whatsapp-says-use-official-whatsapp/">Use Official WhatsApp warning guide</a>.',
      },
    ],
  },
  {
    slug: 'gb-whatsapp-says-use-official-whatsapp',
    path: '/gb-whatsapp-says-use-official-whatsapp/',
    title: 'GB WhatsApp Says Use Official WhatsApp? Fix It Safely',
    description:
      'Seeing “Use Official WhatsApp” in GB WhatsApp? Learn how to switch apps, check chat backup options and troubleshoot login problems without risking your data.',
    keywords: 'gb whatsapp use official whatsapp, switch to official whatsapp, gb whatsapp warning',
    h1: 'GB WhatsApp Says Use Official WhatsApp? Fix It Safely',
    cardSummary:
      'Learn what this warning means and what steps to consider when GB WhatsApp cannot connect normally.',
    blocks: [
      {
        type: 'p',
        html: 'This message usually means WhatsApp does not support the modified client you are using. Installing an older GB WhatsApp build does not guarantee the warning disappears. Confirm the exact text and plan for chat recovery before you uninstall.',
      },
      { type: 'h2', text: 'Why Are You Seeing the “Use Official WhatsApp” Message?' },
      {
        type: 'p',
        html: 'The app detects a non-official client. WhatsApp may limit or block access for unsupported modifications. This section focuses on that prompt—not every possible ban reason.',
      },
      { type: 'h2', text: 'What to Do Before Uninstalling GB WhatsApp' },
      { type: 'h3', text: 'Check Whether Your Chats Are Still Accessible' },
      {
        type: 'p',
        html: 'Open the app while you still can. Export or save important conversations and media you need to keep.',
      },
      { type: 'h3', text: 'Review Your Backup Options' },
      {
        type: 'p',
        html: 'Check backup date, account and storage location. Do not assume a GB WhatsApp backup will restore into official WhatsApp.',
      },
      { type: 'h3', text: 'Save Important Media Separately' },
      {
        type: 'p',
        html: 'Copy critical photos, videos and documents to another folder or cloud storage while access remains.',
      },
      { type: 'h3', text: 'Do Not Uninstall Before Reviewing Your Recovery Options' },
      {
        type: 'p',
        html: 'Uninstalling can remove local data. There is no promise that all chats can be recovered afterward.',
      },
      { type: 'h2', text: 'How to Switch From GB WhatsApp to Official WhatsApp' },
      { type: 'h3', text: 'Step 1: Get the Official WhatsApp App' },
      {
        type: 'p',
        html: 'Install from the official WhatsApp website or a trusted official store channel—not another mod download site.',
      },
      { type: 'h3', text: 'Step 2: Follow the Official Installation Instructions' },
      {
        type: 'p',
        html: 'Use WhatsApp’s normal setup flow with your phone number. Avoid unofficial database swaps or risky migration tricks.',
      },
      { type: 'h3', text: 'Step 3: Verify Your Phone Number' },
      {
        type: 'p',
        html: 'Ensure SMS or voice verification can reach your number. Do not spam verification requests to bypass limits.',
      },
      { type: 'h3', text: 'Step 4: Check Whether Your Chats Can Be Restored' },
      {
        type: 'p',
        html: 'Restoration depends on available backups and compatibility. Migration from unofficial apps is not guaranteed.',
      },
      { type: 'h2', text: "What If Official WhatsApp Still Won't Let You Log In?" },
      {
        type: 'ul',
        items: [
          '<strong>No verification code:</strong> Check country code, number, network and resend timer.',
          '<strong>Temporary restriction:</strong> Wait and use the official app; avoid switching APKs repeatedly.',
          '<strong>Account banned:</strong> Look for <strong>Request review</strong> on the ban screen.',
          '<strong>Installation error:</strong> Verify app source and device compatibility; do not bypass security warnings with unknown files.',
        ],
      },
      { type: 'h2', text: 'Can You Fix the Warning by Installing an Older GB WhatsApp Version?' },
      {
        type: 'p',
        html: 'Not guaranteed. The warning targets unofficial clients in general; repeated downgrades can complicate backup recovery.',
      },
      { type: 'h2', text: 'Frequently Asked Questions' },
      { type: 'h3', text: 'Will I Lose My Chats When Switching to Official WhatsApp?' },
      {
        type: 'p',
        html: 'Outcomes vary. Confirm a recovery plan before uninstalling.',
      },
      { type: 'h3', text: 'Can I Keep Using GB WhatsApp Without Switching?' },
      {
        type: 'p',
        html: 'Access may remain limited. WhatsApp recommends removing unofficial apps and using the official client.',
      },
      { type: 'h3', text: 'What If I Still See the Warning After Installing Official WhatsApp?' },
      {
        type: 'p',
        html: 'Confirm you installed the genuine app, completed registration, and read the on-screen message. For account limits, follow official review steps instead of downloading another mod.',
      },
      {
        type: 'p',
        html: 'Short path: save data → install official WhatsApp → verify number → check restore. Related: <a href="/security-guide/">Security Guide</a>, <a href="/old-versions/">Old Versions</a>, <a href="/why-is-gb-whatsapp-account-banned/">account ban guide</a>.',
      },
    ],
  },
]

export default securityArticles
